import React from 'react';

const DataStatusMessage = ({
  type = 'error', // 'error' or 'refresh'
  message,
  buttonText,
  onButtonClick
}) => {
  const isError = type === 'error';
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <div className={`${isError ? 'bg-red-50 border-red-200' : 'bg-yellow-50 border-yellow-200'} border rounded-lg p-4 max-w-md`}>
        <p className={`${isError ? 'text-red-600' : 'text-yellow-700'} text-center`}>
          {message}
        </p>
        <button
          onClick={onButtonClick}
          className={`mt-4 w-full px-4 py-2 ${isError ? 'bg-red-600 hover:bg-red-700' : 'bg-yellow-600 hover:bg-yellow-700'} text-white rounded-lg`}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default DataStatusMessage;